import React from "react";
import { Check } from "lucide-react";
import { cx } from "components/crm/ui/uiUtils";

const Chip = ({ selected, children, ...props }) => (
  <button
    type="button"
    aria-pressed={selected}
    className={cx(
      "inline-flex h-[46px] items-center gap-3 rounded-xl border bg-white px-3 text-sm font-semibold leading-5 text-ink transition-colors",
      selected
        ? "border-primary"
        : "border-line hover:border-lineStrong hover:bg-gray-50 active:bg-gray-100"
    )}
    {...props}
  >
    {children}
    {selected && <Check size={18} strokeWidth={2} />}
  </button>
);

export default Chip;
